module.exports = __webpack_public_path__ + "img/icon-csv.9433c35d.svg";